export enum  FeeLocation {
    // Carrosserie — Avant
    Hood = 'hood',
    WindshieldFront = 'windshield_front',
    BumperFront = 'bumper_front',
    Fender = 'fender',
    Headlight = 'headlight',

    // Côtés
    Door = 'door',
    Sill = 'sill',
    Mirror = 'mirror',

    // Arrière
    Trunk = 'trunk',
    BumperRear = 'bumper_rear',
    LightRear = 'light_rear',
    WindshieldRear = 'windshield_rear',

    // Toit & vitres
    Roof = 'roof',
    SideWindow = 'side_window',

    // Roues
    Wheel = 'wheel',
}

export const FeeLocationLabel: Record<FeeLocation, string> = {
    [FeeLocation.Hood]: 'Capot',
    [FeeLocation.WindshieldFront]: 'Pare-brise',
    [FeeLocation.BumperFront]: 'Pare-chocs avant',
    [FeeLocation.Fender]: 'Aile',
    [FeeLocation.Headlight]: 'Optique avant',
    [FeeLocation.Door]: 'Porte',
    [FeeLocation.Sill]: 'Bas de caisse',
    [FeeLocation.Mirror]: 'Rétroviseur',
    [FeeLocation.Trunk]: 'Coffre / Hayon',
    [FeeLocation.BumperRear]: 'Pare-chocs arrière',
    [FeeLocation.LightRear]: 'Feu arrière',
    [FeeLocation.WindshieldRear]: 'Lunette arrière',
    [FeeLocation.Roof]: 'Toit',
    [FeeLocation.SideWindow]: 'Vitre latérale',
    [FeeLocation.Wheel]: 'Jante',
}